import React from "react";
import { Iconography, IconographySizes } from "@hid-galaxy-ui/galaxy-react";

const FilterChipDeleteIcon = React.forwardRef<
  HTMLSpanElement,
  React.HTMLAttributes<HTMLSpanElement>
>(({ className, ...props }, ref) => (
  <span
    ref={ref}
    className={`partner-filter-chip-delete-icon ${className ?? ""}`}
    {...props}
  >
    <Iconography icon="xmark" size={IconographySizes.Small} />
  </span>
));

FilterChipDeleteIcon.displayName = "FilterChipDeleteIcon";

export default FilterChipDeleteIcon;
